import { PDFDocument } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import FONT_URL from '../assets/IBMPlexSans-Regular.ttf';

export async function getFont(pdfDoc: PDFDocument) {
	pdfDoc.registerFontkit(fontkit);
	const fontBytes = await fetch(FONT_URL).then((result) =>
		result.arrayBuffer(),
	);
	const font = await pdfDoc.embedFont(fontBytes);
	return font;
}
